"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchExpression = void 0;
const LogicalExpression_1 = require("./LogicalExpression");
class BranchExpression {
    constructor(initObj) {
        this.logicalOperator = 'or';
        this.expression = [];
        this.emptyExpression = false;
        if (!initObj) {
            this.emptyExpression = true;
            return;
        }
        this.logicalOperator = initObj.logicalOperator;
        this.expression = initObj.expressions.map((expr) => new LogicalExpression_1.LogicalExpression(expr));
    }
    validate(extras) {
        if (this.emptyExpression) {
            return true;
        }
        if (this.logicalOperator === 'and') {
            return this.expression.every((expr) => expr.validate(extras));
        }
        else {
            return this.expression.some((expr) => expr.validate(extras));
        }
    }
}
exports.BranchExpression = BranchExpression;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnJhbmNoRXhwcmVzc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvQnJhbmNoRXhwcmVzc2lvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwyREFBd0Q7QUFHeEQsTUFBYSxnQkFBZ0I7SUFJM0IsWUFBWSxPQUFvQjtRQUhoQyxvQkFBZSxHQUFXLElBQUksQ0FBQztRQUMvQixlQUFVLEdBQTZCLEVBQUUsQ0FBQztRQUMxQyxvQkFBZSxHQUFZLEtBQUssQ0FBQztRQUUvQixJQUFJLENBQUMsT0FBTyxFQUFFO1lBQ1osSUFBSSxDQUFDLGVBQWUsR0FBRyxJQUFJLENBQUM7WUFDNUIsT0FBTztTQUNSO1FBQ0QsSUFBSSxDQUFDLGVBQWUsR0FBRyxPQUFPLENBQUMsZUFBZSxDQUFDO1FBQy9DLElBQUksQ0FBQyxVQUFVLEdBQUcsT0FBTyxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQ3ZDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxJQUFJLHFDQUFpQixDQUFDLElBQUksQ0FBQyxDQUN0QyxDQUFDO0lBQ0osQ0FBQztJQUNELFFBQVEsQ0FBQyxNQUFjO1FBQ3JCLElBQUksSUFBSSxDQUFDLGVBQWUsRUFBRTtZQUN4QixPQUFPLElBQUksQ0FBQztTQUNiO1FBQ0QsSUFBSSxJQUFJLENBQUMsZUFBZSxLQUFLLEtBQUssRUFBRTtZQUNsQyxPQUFPLElBQUksQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7U0FDL0Q7YUFBTTtZQUNMLE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztTQUM5RDtJQUNILENBQUM7Q0FDRjtBQXhCRCw0Q0F3QkMifQ==